export class JokesModel {
  constructor(
    public questionBanner: string,
    public answerBanner: string,
    public question: string,
    public answer: string,
    public answerEmoji: string
  ) {}
}
